export default {
  setCookie(name, value, expireSeconds = 60 * 60 * 24 * 30, domain) {
    console.log('aa');
    let cookieString = name + '=' + escape(value),
      date = new Date();
    date.setTime(date.getTime() + expireSeconds * 1000);
    if (domain) cookieString += '; domain=' + domain;
    document.cookie = cookieString + '; path=/; expires=' + date.toGMTString();
  },

  getUserToken() {
    if (this.getCookie('token')) {
      return this.getCookie('token');
    }
    return false;
  },

  getCookie(name) {
    let arr;
    let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
    if (document.cookie.match(reg)) {
      arr = document.cookie.match(reg);
      return unescape(arr[2]);
    } else {
      return false;
    }
  },

  deleteCookie(name, domain) {
    document.cookie = name + '=; Max-Age=0; domain=' + domain + ';';
  },

  clearLoginUserCookie() {
    this.setCookie('token', '');
    this.setCookie('uuid', '');
    localStorage.removeItem('token');
    localStorage.removeItem('sh-userInfo');
  },
  strlen(str) {
    let len = 0;
    for (var i = 0; i < str.length; i++) {
      const c = str.charCodeAt(i);
      //单字节加1
      if ((c >= 0x0001 && c <= 0x007e) || (0xff60 <= c && c <= 0xff9f)) {
        len++;
      } else {
        len += 2;
      }
    }
    return len;
  },

  formatTime(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    // 补零函数（确保两位数）
    const pad = (num) => num.toString().padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
  },

  genUUID4() {
    let r = Math.random,
      p = '0000000',
      n = 0x100000000,
      a = ((r() * n) >>> 0).toString(16),
      b = ((((r() * n) & 0xffff4fff) | 0x4000) >>> 0).toString(16),
      c = ((((r() * n) & 0xbfffffff) | 0x80000000) >>> 0).toString(16),
      d = ((r() * n) >>> 0).toString(16);

    if (a.length < 8) {
      a = (p + a).slice(-8);
    }
    if (b.length < 8) {
      b = (p + b).slice(-8);
    }
    if (c.length < 8) {
      c = (p + c).slice(-8);
    }
    if (d.length < 8) {
      d = (p + d).slice(-8);
    }

    return [a, b.slice(0, 4), b.slice(4), c.slice(0, 4), c.slice(4) + d].join(
      '-'
    );
  },
  /**
   * 生成STKUUID,设备id(大数据did)
   * @method {{getSTKUUID}}
   * @return {[type]} [description]
   */
  getSTKUUID() {
    let uuid = this.getCookie('__STKUUID');
    if (uuid == '') {
      uuid = this.genUUID4();
      if (location.host.search('.shuziwenbo.cn') != -1) {
        this.setCookie('__STKUUID', uuid, 9000, '.shuziwenbo.cn');
      } else {
        this.setCookie('__STKUUID', uuid, 9000);
      }
    }
    return uuid;
  },
  // 使用正则表达式去除 HTML 标签
  filterHTML(str) {
    return str.replace(/<[^>]+>|&nbsp;/gi, '');
  },
  // 继续字符串里面的话题，飘蓝
  // 把 /n 替换成 <br />
  formatTopic1(str) {
    let returnStr = str;
    returnStr = returnStr.replace(
      /#(.*?) /g,
      '<break contenteditable="false" class="c-blue">#$1 </break><sub>&nbsp;</sub>'
    );
    returnStr = returnStr.replace(/\n/g, '<br>');
    return returnStr;
  },
  formatTopic(str) {
    console.log(str);
    return str.replace(
      /#\S+/g,
      (match) =>
        `<break contenteditable="false" class="c-blue">${match}<sub>&nbsp;</sub></break>`
    );
  },
  insertTopicChip(editor, topicName, savedRange) {
    if (!editor || !topicName) return null;
    editor.focus();
    const selection = window.getSelection();
    if (!selection) return null;
    selection.removeAllRanges();
    if (
      savedRange &&
      savedRange.startContainer &&
      editor.contains(savedRange.startContainer)
    ) {
      selection.addRange(savedRange);
    } else {
      const end = document.createRange();
      end.selectNodeContents(editor);
      end.collapse(false);
      selection.addRange(end);
    }
    const range = selection.getRangeAt(0);
    const chip = document.createElement('break');
    chip.setAttribute('contenteditable', 'false');
    chip.classList.add('c-blue');
    chip.innerHTML = '#' + topicName + '<sub>&nbsp;</sub>';
    range.insertNode(chip);
    const next = document.createRange();
    next.setStartAfter(chip);
    next.collapse(true);
    selection.removeAllRanges();
    selection.addRange(next);
    return next;
  },
  collectTopicIds(content, topicList) {
    const names = [];
    const text = content || '';
    const re = /#(\S+)/g;
    let match = re.exec(text);
    while (match) {
      names.push(match[1]);
      match = re.exec(text);
    }
    if (!names.length) return '';
    if (!topicList || !topicList.length) return null;
    const seen = {};
    const ids = [];
    names.forEach((name) => {
      const topic = topicList.find((item) => item.topicName === name);
      if (!topic || topic.topicId === undefined || topic.topicId === null || topic.topicId === '') {
        return;
      }
      const id = String(topic.topicId);
      if (!id || id === '0' || seen[id]) return;
      seen[id] = true;
      ids.push(id);
    });
    return ids.join(',');
  },
  topicsFromFeed(feed, topicList) {
    const list = topicList || [];
    const byId = {};
    const byName = {};
    list.forEach((item) => {
      if (!item) return;
      if (item.topicId !== undefined && item.topicId !== null && item.topicId !== '') {
        byId[String(item.topicId)] = item;
      }
      if (item.topicName) byName[item.topicName] = item;
    });
    const result = [];
    const push = (id, name) => {
      const known = id !== undefined && id !== null && id !== '' ? byId[String(id)] : null;
      const topicId = known ? known.topicId : id;
      const topicName = (known && known.topicName) || name || '';
      const key = topicId !== undefined && topicId !== null && topicId !== ''
        ? String(topicId)
        : topicName;
      if (!key || key === '0') return;
      result.push({
        topicId: topicId === undefined || topicId === null ? '' : topicId,
        topicName,
      });
    };
    const source = feed || {};
    if (Array.isArray(source.topicIds) && source.topicIds.length) {
      source.topicIds.forEach((id) => push(id, ''));
    } else if (typeof source.topicIds === 'string' && source.topicIds.trim()) {
      source.topicIds.split(',').forEach((id) => push(id.trim(), ''));
    }
    const rawTopics = source.topics;
    if (!result.length && Array.isArray(rawTopics) && rawTopics.length && rawTopics[0] && (rawTopics[0].topicId || rawTopics[0].topicName || rawTopics[0].id)) {
      rawTopics.forEach((topic) => {
        if (!topic || typeof topic !== 'object') return;
        push(topic.topicId || topic.id, topic.topicName || topic.title || topic.name || '');
      });
    }
    if (!result.length && source.content) {
      const seen = {};
      const re = /#(\S+)/g;
      let match = re.exec(source.content);
      while (match) {
        const topic = byName[match[1]];
        const name = match[1];
        if (topic && !seen[name]) {
          seen[name] = true;
          push(topic.topicId, topic.topicName);
        }
        match = re.exec(source.content);
      }
    }
    return result.filter((topic) => topic.topicId !== '' && topic.topicId !== undefined);
  },
  formatTopicIds(topics) {
    const ids = [];
    (topics || []).forEach((topic) => {
      if (!topic || topic.topicId === undefined || topic.topicId === null || topic.topicId === '') return;
      const id = String(topic.topicId);
      if (!id || id === '0') return;
      ids.push(id);
    });
    return ids.join(',');
  },
  normalizeContentTags(contentTags) {
    if (!Array.isArray(contentTags)) return [];
    const seen = {};
    const result = [];
    contentTags.forEach((tag) => {
      if (!tag || tag.tagId === undefined || tag.tagId === null || tag.tagId === '') {
        return;
      }
      const id = String(tag.tagId);
      if (!id || id === '0' || seen[id]) return;
      seen[id] = true;
      result.push({
        tagId: tag.tagId,
        tagName: tag.tagName || id,
      });
    });
    return result;
  },
  formatContentTagIds(tags) {
    return this.normalizeContentTags(tags)
      .map((tag) => String(tag.tagId))
      .join(',');
  },
  ensureHttps(url) {
    if (typeof url !== 'string') return url;
    // 只替换 http:// 开头的，https:// 或其他协议不变
    if (url.startsWith('http://')) {
      return 'https://' + url.slice(7);
    }
    return url;
  },
};
